import React, { useState, useRef } from 'react';
import { useRouteMatch, Switch, useHistory, Route, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import moment from 'moment';
import Box from 'ui-box';
import { Persist } from 'formik-persist';
import { ReactComponent as DoctorFeedbackSvg } from '../../../assets/icons/feedback/doctor-feedback.svg';
import useScreeningData from '../../../containers/hooks/useScreeningData';
import { getMobileFeedbackRoutes } from '../../../routes/mobile/feedbackRoutes.js';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import FeedBackNavBtn from '../../../components/mobile/feedback/FeedBackNavBtn';
import { errorNotification } from '../../../utils/notification-helpers';

const FeedbackScreenWrapper = ({prevRoutePath, children, ...restNavBtnProps }) => (
  <>
    <Box display="flex" justifyContent="center">
      <DoctorFeedbackSvg style={{ margin: '20', maxWidth: '80%' }} />
    </Box>
    {children}
    <FeedBackNavBtn prevRoutePath={prevRoutePath} {...restNavBtnProps} />
  </>
);

function MobileFeedbackScreen() {
  const { t } = useTranslation(['common', 'feedback']);
  const match = useRouteMatch();
  const history = useHistory();
  const ref = useRef(null);

  const { path } = match;
  const { setScreeningData } = useScreeningData();

  const initialValues = {
    call_with_doctor: '',
    what_imporove: '',
    rating: 0,
  };

  const validateScreeningData = (values) => {
    const {
      call_with_doctor,
      what_imporove,
      rating
    } = values;

    if (call_with_doctor.length === 0) {
      return false;
    }

    if (what_imporove.length === 0) {
      return false;
    }

    if (rating === 0) {
      return false;
    }

    return true;
  };

  const renderRoutes = (routes, total = routes.length) =>
    routes.map(({ id: count, path: p, component: Component, props: componentProps }) => {
      const {
        isFirst,
        nextRoutePath,
        prevRoutePath,
        fieldName,
        isLastQuestion,
        ...restComponentProps
      } = componentProps;

      // if(employeeStatus.covid_screening_done){
      //   return <Redirect to={{ pathname: '/welcome/status' }} />
      // }

      return (
        <Route key={p} path={p}>
          <FeedbackScreenWrapper
            isFirst={isFirst}
            isLast={isLastQuestion}
            nextRoutePath={nextRoutePath}
            prevRoutePath={prevRoutePath}
            fieldName={fieldName}
          >
            <Component fieldName={fieldName} {...restComponentProps} />
          </FeedbackScreenWrapper>
        </Route>
      );
    });  

  return (
    <>
      <Formik
        innerRef={ref}
        enableReinitialize
        initialValues={initialValues}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          const data = { ...values };
          history.push(`/feedback/finish`);
          //const isValid = validateScreeningData(data);

          /*if (!isValid) {
            errorNotification(t('common:form.error.submit'));
            setSubmitting(false);
            resetForm({ values: initialValues });
            history.push(`/`);
          } else {
            try {
              setScreeningData(data);
              setSubmitting(false);
              resetForm({ values: initialValues });
              history.push(`/feedback/finish`);
            } catch (err) {
              console.error(err);
              errorNotification(t('common:form.error.submit'));
              setSubmitting(false);
              resetForm({ values: initialValues });
              history.push(`/`);
            }
          }*/
        }}
      >
        {({ isSubmitting, values }) => (
          <Form loading={isSubmitting.toString()}>
            <>
              {isSubmitting}
              <Switch>
                {renderRoutes(
                  getMobileFeedbackRoutes(),
                  getMobileFeedbackRoutes().length - 1
                )}
                <Redirect to={`${path}/call-with-doctor`} />
              </Switch>
            </>
            {!isSubmitting && <Persist name="covid-screening-form" />}
            {isSubmitting ? (
              <LoadingSpinner position="full" transparent={false} />
            ) : null}
          </Form>
        )}
      </Formik>
    </>
  );
}

const styles = {
  title: {
    fontWeight: "400", 
    fontSize: "18px", 
    lineHeight: "26px", 
    textAlign: "center", 
    letterSpacing: "0.02em", 
    color: "#404047"
  },
  divider: {
    fontSize: 15,
    fontWeight: 400,
    color: '#404047',
    margin: 0
  },
  selectOption: {
    fontWeight: "300", 
    fontSize: "15px", 
    lineHeight: "20px", 
    textAlign: "center", 
    letterSpacing: "0.02em", 
    color: "#15A9E1"
  }
}

export default MobileFeedbackScreen;
